import { CheckSensorBatchFiles, CreateSensorBatch, EditSensorBatch, SensorBatch } from "../models/sensor-batch-models";
import { deleteRequest, getFileRequest, getRequest, postRequest, putRequest, RequestDataType } from "../../../../services/api";

export const getAllSensorBatches = async () =>
    (await getRequest("/sensorBatches") || []) as SensorBatch[];

export const getSensorBatchPdf = async (sensorBatchId: string) =>
    await getFileRequest(`/sensorBatches/GetPdf${sensorBatchId}`);

export const postNewSensorBatch = async (data: Partial<CreateSensorBatch>) =>
    await postRequest("/sensorBatches", data, RequestDataType.FormData);

export const getSensorBatchCsv=async (sensorBatchId: string) =>
    await getFileRequest(`/sensorBatches/GetCsv${sensorBatchId}`);

export const editSensorBatch = async (data: Partial<EditSensorBatch>) =>
    await putRequest("/sensorBatches", data, RequestDataType.FormData);

export const deleteSensorBatch = async (sensorBatchId: string) =>
    await deleteRequest("/sensorBatches", sensorBatchId);

export const checkSensorBatchFiles= async (sensorBatchId: string)=>
    await getRequest(`/sensorBatches/CheckFiles${sensorBatchId}`)as CheckSensorBatchFiles;
